/**
 @ngdoc directive
 @name autofocus

 @description
 Using html5 default attribute autofocus as a directive in AngularJS to work on dynamically loaded templates.

 @usage
 <input type="text" autofocus>

 */

(function() {
    'use strict';
    var autofocus = function ($timeout) {
        return {
            restrict: 'A',
            link: function($scope, $element) {
                $timeout(function() {
                    $element[0].focus();
                });
            }
        };
    };

    autofocus.$inject = ['$timeout'];
    angular.module('app').directive('autofocus', autofocus);

}());